import { useMyUrl, useTranslation } from '@gimlite/common';
import { Page, Zone } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { iconGlobalEntity } from '../../common/mapper/icon.mapper';
import { IncidentDetails } from '../../composition/details/incident.details';
import { IncidentList } from '../../composition/list/incident.list';

export const IncidentPage = observer(() => {
  const { t } = useTranslation();
  const { parkingId, incidentId = null } = useParams();
  const navigate = useNavigate();
  const { getParamsUrlString } = useMyUrl({});

  const [selectedIncident, setSelectedIncident] = useState<string | null>(
    incidentId,
  );

  useEffect(() => {
    if (selectedIncident) {
      navigate(
        `/${parkingId}/incidents/${selectedIncident}?${getParamsUrlString}`,
      );
    }
  }, [selectedIncident]);

  useEffect(() => {
    setSelectedIncident(null);
  }, [parkingId]);

  return (
    parkingId && (
      <Page>
        <Zone
          config={{
            zones: [['list', 'details']],
            rows: ['1fr'],
            columns: ['1fr', '1fr'],
          }}
        >
          <Zone.Area
            config={{
              area: 'list',
            }}
          >
            <IncidentList
              widget={{
                title: t('listOfIncidents'),
                icon: iconGlobalEntity['incident'],
              }}
              parkingId={parkingId}
              setSelectedIncident={(id: string) => setSelectedIncident(id)}
            />
          </Zone.Area>

          <Zone.Area
            config={{
              area: 'details',
            }}
          >
            <IncidentDetails
              widget={{ title: t('detailsOfIncidents') }}
              technicalEventId={selectedIncident}
            />
          </Zone.Area>
        </Zone>
      </Page>
    )
  );
});
